import React, { useEffect } from 'react';
import clsx from 'clsx';
import moment from 'moment';

import useYesrSelectbox from '../../hooks/selectbox/useYesrSelectbox';

const year = () => {
  let result = [];
  const startYear = Number(moment(new Date()).subtract(20, "Y").format("YYYY"));
  const endYear = Number(moment(new Date()).format("YYYY"));
  for (let i = startYear; i <= endYear; i++) {
    result.push(i);
  }
  return result;
}

function YearSelectBox() {
  const [open, value, onOpen, onClick, onReset] = useYesrSelectbox();
  useEffect(() => {
    return () => onReset();
  }, []);

  return (
    <div className={
      clsx("new-select", open && 'opened')
    }>
      <div
        className="selected_txt"
        onClick={onOpen}
      >
        { value ? `${value}년` : "출생년도"}
      </div>
      <div className="select_option">
        <ul>
          {
            year().map((item) => (
              <li key={item}>
                <button
                  type="button"
                  value={item}
                  onClick={() => onClick(item)}
                  className={clsx(value === item && "selected")}
                >
                  {item}년
                </button>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  );
}

export default YearSelectBox;